import { Component, OnInit, NgZone, transition } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProgramService } from '../../../services/program.service';
import { MemberService } from '../../../member.service';
import { TryoutMemberService } from '../../../services/tryout_Services/tryout-member.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { FeeColumnFilterPanelService } from '../../../services/fee-column-filter-panel.service';
import { PlayerAdjustmentService } from '../../../services/player-adjustment.service';
import { InviteMemberDataService } from '../../../shared-services/invite-member-data.service';
import { Subject } from 'rxjs/Subject';
import { DownloadUtil, Observable, Store, AppState, AppFields, StorageUtil, DocumentUtil, BehaviorSubject, filter, InputUtil, map, take } from '../../../store';
import { UserInfo } from '../../../interfaces';
import * as lodash from 'lodash';
import * as moment from 'moment';
import { AlertService, CommonService } from '../../../services';
import { TryoutProgramService } from '../../../services/tryout_Services/tryout-program.service';

@Component({
  selector: 'app-tryout-members',
  templateUrl: './tryout-members.component.html',
  styleUrls: ['./tryout-members.component.css']
})
export class TryoutMembersComponent implements OnInit {

  public currentYear: number = new Date().getFullYear();

  public changingValue: Subject<number> = new Subject();
  public clubMembers = [];
  public names: any;
  public selectedAll: any;
  public selectedRecordIndex = [];
  public selectedRecordCUPFIDList = [];
  public selectedRecordInvite = [];
  public isSelectAllCheckBox = false;
  public isCheckAllCheckBox = false;
  public member_status = '0';
  public payment_status = '0';
  public NoOfTryoutRegisteredMembers: number;
  public NoOfInvitedMembers: number;
  public NoOfNotInvitedMembers: number;
  public NoOfSelectedMember: number;
  public MemberUserID: number;
  public isOpenConfirmDeletePopup = false;
  public currentUrl = '';
  public routeParams;
  public popupConfirmForm: FormGroup;
  public alphaNumericPattern = /^[a-zA-Z ]+$/;
  public onlyDigitPattern: RegExp;
  public routeStatus: string;
  public is_show_visible_column_panel = false;
  public searchMemberForm: FormGroup;
  public isShowPlayerAdjustment = false;
  public isinviteMember = false;
  public isShowMemberSearch = false;
  public clubUserProgramFeeID;
  public isConfirmWarning = false;
  public isClose = false;
  public clubProgramFeeID;
  public ProgramName: string;
  public MemberIdData: string;
  public MemberStatus: string;
  public paymentTypes: any[] = [
    { 'key': '1', 'value': 'Paid' },
    { 'key': '0', 'value': 'Unpaid' }
  ];
  public invitationStatus: any[] = [
    { 'key': 0, 'value': 'Invitation Sent' },
    { 'key': 1, 'value': 'Signed Up' },
    { 'key': 2, 'value': 'Pending' },
  ];

  // Fee Plan
  public feePlanForm: FormGroup;
  public popupConfirmFeePlanForm: FormGroup;
  public isOpenConfirmCorrectPopup = false;
  public validationMessages = {};
  public ismessageSelected: boolean;
  public issetQuestionselected: boolean;
  public iscustomQuestionSelected: boolean;

  public searchMemberControls: any[];
  public MemberUserIDArray: any[];
  assignModalOpen: boolean;
  searchModalOpen: boolean;
  answers = new BehaviorSubject(null);
  questionAndAnswerList: any;
  selectedMember;

  itemsPerPage = 10;
  p = 1;

  showModal = false;
  formPath = '';
  allForms = [];

  public reverse = false;
  public sortValue = 'dateRegistered'; // Default Sorting Value

  controls: any[] = [
    { name: 'firstName', type: 'text', title: 'First Name' },
    { name: 'lastName', type: 'text', title: 'Last Name' },
    { name: 'gender', type: 'select', title: 'Gender', options: [{ text: 'Male', value: 'm' }, { text: 'Female', value: 'f' }] },
    { name: 'age', type: 'number', title: 'Age' },
    { name: 'birthYear', type: 'select', title: 'Birth Year', options: [] },
    { name: 'email', type: 'text', title: 'Email' },
    { name: 'paymentStatusVal', type: 'select', title: 'Payment Type', options: [{ text: 'Paid', value: 1 }, { text: 'Unpaid', value: 2 }] },
    {
      name: 'inviteStatus', type: 'select', title: 'Invitation Type', options: [
        { text: 'PENDING', value: 'PENDING' }, { text: 'INVITATION SENT', value: 'INVITATION SENT' }, { text: 'SIGNED UP', value: 'SIGNED UP' }
      ]
    },
    { name: 'invitedTeamID', type: 'select', title: 'Invited Team', options: [], isArray: true },
    { name: 'assignedTeam', type: 'select', title: 'Assigned Team', options: [], isArray: true },
    { name: 'feeName', type: 'select', title: 'Fee/Group Name', options: [], isArray: true }
  ];

  user: Observable<UserInfo>;
  filteredMembers = [];
  emailModalOpen: boolean;
  selectedStatus = 0;
  adjustingFee: any;
  adjustingFeeOpen: boolean;
  reinvite: boolean;
  isMedicalQuestionSelected: boolean;

  constructor(
    private fb: FormBuilder,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private memberService: MemberService,
    private tryoutMemberService: TryoutMemberService,
    private inviteMemberDataService: InviteMemberDataService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService,
    private store: Store<AppState>,
    private commonService: CommonService,
    private tryoutProgramService: TryoutProgramService,
    private alertService: AlertService
  ) {
    this.onlyDigitPattern = /^-?(0|[1-9]\d*)?$/;

    this.validationMessages = {
      'FeePlanRequired': 'Please select an option.',
      'OnlyDigit': 'Please enter only number.',
    };
    this.searchMemberControls = ['FirstName', 'LastName', 'Age', 'Gender', 'Email', 'PaymentType', 'Invitation'];
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
    this.ismessageSelected = false;
    this.issetQuestionselected = false;
    this.iscustomQuestionSelected = false;

    this.user = this.store.select(AppFields.App, AppFields.User);
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    const programID = this.routeParams.id;
    const programName = this.routeParams.name;
    const status = this.routeParams.status;
    this.routeStatus = status.replace('-', ' ');

    this.tryoutMemberService.getAnswers(programID).subscribe(res => {
      this.answers.next(res);
    });

    this.tryoutMemberService.getClubProgramQuestionsAndAnswersByClubProgramID(programID).subscribe(res => {
      this.questionAndAnswerList = res.map(item => ({
        userID: item.userID,
        order: item.order,
        label: item.label,
        answer: item.answer
      }));
    });

    if (status === 'registered') {
      this.member_status = '0';
    } else if (status === 'invited') {
      this.member_status = '1';
    } else if (status === 'not-invited') {
      this.member_status = '2';
    }

    /* Fixed: same page refresh content. */
    this.router.routeReuseStrategy.shouldReuseRoute = function (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
      return false;
      // return future.routeConfig === curr.routeConfig;
    };

    this.filterMembers(programName, programID, this.member_status);

    this.popupConfirmForm = this.fb.group({
      confirm_member_delete: [null, [Validators.required, Validators.pattern(this.alphaNumericPattern)]]
    });
    /* Search Member Reactive Form */
    this.searchMemberForm = this.fb.group({
      FirstName: [null],
      LastName: [null],
      Gender: [null],
      Age: [null, Validators.compose([Validators.pattern(this.onlyDigitPattern)])],
      Email: [null],
      PaymentType: [null],
      Invitation: [null],
    });
    this.initFeePlanForm();
    // this.getMemberCount();

    this.store.select(AppFields.App, AppFields.ClubProgramFees)
      .pipe(
        filter(res => res !== null),
        take(1)
      ).subscribe(res => this.controls[8].options = (res.teams || []).map(t => ({ text: t.name, value: t.teamID })));
  }

  getClubProgramQuestionsAndAnswersByClubProgramID() {
    this.tryoutMemberService.getClubProgramQuestionsAndAnswersByClubProgramID(this.routeParams.id).subscribe(res => {
      this.questionAndAnswerList = res.map(item => ({
        userID: item.userID,
        order: item.order,
        label: item.label,
        answer: item.answer
      }));
    });
  }

  getMemberCount() {
    this.tryoutMemberService.getTryoutMemberCounts(this.routeParams.id, StorageUtil.userID).subscribe(rs => {
      this.NoOfTryoutRegisteredMembers = rs[0].registeredMembers;
      this.NoOfInvitedMembers = rs[0].invitedMembers;
      this.NoOfNotInvitedMembers = rs[0].notInvitedMembers;
    });
  }

  setOrder(value: string) {
    this.reverse = !this.reverse;
    this.sortValue = value;
    const members = lodash.sortBy(this.filteredMembers, value === 'lastName' ? ['lastNameLower', 'firstNameLower', 'middleNameLower'] : value);
    //const members = lodash.sortBy(this.filteredMembers, value === 'lastName' ? ['lastName', 'firstName', 'middleName'] : value);
    this.filteredMembers = this.reverse ? members.reverse() : members;
  }

  checkPaymentStatus(PStatus) {
    if (PStatus.includes('INVITATION SENT')) {
      this.payment_status = '0';
    } else if (PStatus.includes('SIGNED UP')) {
      this.payment_status = '1';
    } else if (PStatus.includes('PENDING')) {
      this.payment_status = '2';
    }
    return true;
  }

  inviteMember(reinvite: boolean) {
    this.reinvite = reinvite;
    this.isinviteMember = true;
    this.isShowMemberSearch = false;
    this.isShowPlayerAdjustment = false;
    this.openSideOverlay();
    // const data = {
    //   'userId' : this.selectedRecordIndex,
    //   'inviteID' : this.selectedRecordInvite
    // };
    const data = this.selectedRecordIndex;

    this.getmberID(data);
  }

  declineUsers() {
    this.spinnerService.show();
    this.memberService.declineMembers(Number(this.routeParams.id), this.selectedMembers.map(m => m.userID)).subscribe(() => {
      this.getMembersbyStatus(this.member_status);
    });
  }

  didNotMakeUsers() {
    this.spinnerService.show();
    this.memberService.didNotMakeMembers(Number(this.routeParams.id), this.selectedMembers.map(m => m.userID)).subscribe(() => {
      this.getMembersbyStatus(this.member_status);
    });
  }

  onAssignMember() {
    this.assignModalOpen = true;
  }

  onAssigned(success: boolean) {
    if (success) {
      this.getMembersbyStatus(status);
    }

    this.assignModalOpen = false;
  }

  getmberID(data) {
    this.inviteMemberDataService.sendData(data);
  }


  selectedRecord(i, j, cupfID, e) {
    if (e.target.checked) {
      this.filteredMembers.forEach((x) => {
        if (x.userID == i && x.inviteStatusID == j) {
          x.isChecked = true
        }
      });
      this.selectedRecordIndex.push(i);
      this.selectedRecordCUPFIDList.push({
        userID: i,
        clubUserProgramFeeID: cupfID
      });

      this.selectedRecordInvite.push(j);
    } else {
      this.filteredMembers.forEach((x) => {
        if (x.userID == i && x.inviteStatusID == j) {
          x.isChecked = false
        }
      });
      this.isCheckAllCheckBox = false;
      this.selectedRecordIndex.splice(this.selectedRecordIndex.indexOf(i), 1);
      this.selectedRecordCUPFIDList.splice(this.selectedRecordCUPFIDList.findIndex(x => x.userID == i), 1);
      this.selectedRecordInvite.splice(this.selectedRecordInvite.indexOf(j), 1);
    }
    // For enable status/delete button.
    this.NoOfSelectedMember = this.selectedRecordIndex.length;
    console.log("this.NoOfSelectedMember =>", this.NoOfSelectedMember);

    //console.log("this.selectedRecordCUPFIDList =>", this.selectedRecordCUPFIDList);
  }


  selectAll() {
    if (this.isSelectAllCheckBox) {
      this.resetCheckboxSelection();
    } else {
      this.isSelectAllCheckBox = true;
      this.isCheckAllCheckBox = true;
      const l = this.filteredMembers.length;
      this.filteredMembers.forEach((x) => {
        x.isChecked = true
      });
      this.selectedRecordIndex.length = 0;
      this.selectedRecordCUPFIDList.length = 0;
      this.selectedRecordInvite.length = 0;
      for (let i = 0; i < l; i++) {
        this.selectedRecordIndex.push(this.filteredMembers[i].userID);
        this.selectedRecordCUPFIDList.push({
          userID: this.filteredMembers[i].userID,
          clubUserProgramFeeID: this.filteredMembers[i].clubUserProgramFeeID
        });
        this.selectedRecordInvite.push(this.filteredMembers[i].inviteStatusID);
      }
    }
    // For enable status/delete button.
    this.NoOfSelectedMember = this.selectedRecordIndex.length;
    console.log("this.NoOfSelectedMember =>", this.NoOfSelectedMember);
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.html(message, status, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }

  deleteSelectedMemberRecords(event) {
    this.openPopup();
  }

  openPopup() {
    this.isOpenConfirmDeletePopup = true;
  }

  closePopup() {
    this.removeValidaion('confirm_member_delete');
    this.isOpenConfirmDeletePopup = false;
    this.isConfirmWarning = false;
    this.isClose = true;
    this.popupConfirmForm.reset();
    this.removeConfirmFormValidation();

  }

  removeConfirmFormValidation() {
    const control = this.popupConfirmForm.get('confirm_member_delete');
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }


  isDeleteTextMatched(confirmWithText) {
    const val = this.popupConfirmForm.get('confirm_member_delete').value;
    if (val) {
      return (val.trim() === confirmWithText) ? true : false;
    }
  }

  isConfirmDeleteValid() {
    return this.popupConfirmForm.get('confirm_member_delete').errors
      && (this.popupConfirmForm.get('confirm_member_delete').touched
        || this.popupConfirmForm.get('confirm_member_delete').dirty);
  }

  validateUi() {
    Object.keys(this.popupConfirmForm.controls).forEach(field => {
      const control = this.popupConfirmForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  removeValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

  requiredValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.enable();
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }

  onPopUpConfirm(event, formValue, confirmWithText) {
    event.stopPropagation();
    const flag = this.isDeleteTextMatched(confirmWithText);
    if (flag) {
      event.target.innerHTML = 'Deleting <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      const l = this.selectedMembers.filter(m => m.inviteStatusID === 0).length;

      const ids = this.selectedMembers.filter(m => m.inviteStatusID === 0).map(m => m.clubUserProgramFeeID).join(',');
      const invitedMembers = this.selectedMembers.filter(m => m.inviteStatusID === 1);
      if (invitedMembers.length) {
        this.alertMessage('warn', invitedMembers.map(x => `${x.firstName} ${x.lastName}`).join(', ') + ' cannot be deleted.');
      }
      if (!ids) {
        event.target.innerHTML = 'Confirm';
        this.NoOfSelectedMember = 0;
        event.target.disabled = false;
        this.closePopup();
        return;
      }
      /* Delete selected Forms. */
      this.memberService.deleteMembers(ids).subscribe((data) => {
        event.target.innerHTML = 'Confirm';
        this.NoOfSelectedMember = 0;

        this.closePopup();
        this.clubMembers = this.clubMembers.filter(x => this.selectedMembers.indexOf(x) === -1);
        this.filteredMembers = this.clubMembers.slice();
        this.getMemberCount();
        event.target.disabled = false;
        // this.refreshReocrds();
        if (l === 1) {
          this.alertMessage('success', 'A Member successfully deleted.');
        } else {
          this.alertMessage('success', 'Member successfully deleted.');
        }
      }, error => {
        console.log(error);
      });
    } else {
      this.isConfirmWarning = true;
    }
  }

  getMembersbyStatus(status) {
    this.getClubProgramQuestionsAndAnswersByClubProgramID();

    const programName = this.routeParams.name;
    const programFeeID = this.routeParams.id;

    this.spinnerService.show();

    let s = '';
    if (+status === 0) {
      s = 'registered';
    } else if (+status === 1) {
      s = 'invited';
    } else if (+status === 2) {
      s = 'not-invited';
    }

    if (+this.member_status !== +status) {
      //this.router.navigateByUrl(this.baseLink + programName + '/' + programFeeID + '/' + s);
    } else {
      this.tryoutMemberService.getTryoutMembers(programFeeID, status || 0)
        .subscribe(rs => {
          this.clubMembers = rs;

          this.clubMembers.map(x => {
            x.lastNameLower = (x.lastName != null ? x.lastName.toLowerCase() : null)
            x.firstNameLower = (x.firstName != null ? x.firstName.toLowerCase() : null)
            x.middleNameLower = (x.middleName != null ? x.middleName.toLowerCase() : null)
          });

          this.filteredMembers = this.clubMembers.slice();
          this.controls[4].options = lodash.uniqBy<any>(this.clubMembers.map(x => ({ text: x.birthYear, value: x.birthYear })), 'value');
          this.spinnerService.hide();
        });
    }
  }
  clickOnMember() {

    this.ismessageSelected = true;
    this.issetQuestionselected = false;
    this.iscustomQuestionSelected = false;
    this.isMedicalQuestionSelected = false;
  }
  clicksetQuestion() {

    this.issetQuestionselected = true;
    this.ismessageSelected = false;
    this.iscustomQuestionSelected = false;
    this.isMedicalQuestionSelected = false;
  }
  clickcustomQuestion() {
    this.iscustomQuestionSelected = true;
    this.ismessageSelected = false;
    this.issetQuestionselected = false;
    this.isMedicalQuestionSelected = false;
  }
  clickMedicalQuestion() {
    this.iscustomQuestionSelected = false;
    this.ismessageSelected = false;
    this.issetQuestionselected = false;
    this.isMedicalQuestionSelected = true;
  }
  filterMembers(programName, programFeeID, status) {
    this.spinnerService.show();
    this.tryoutMemberService.getTryoutMembers(programFeeID, status)
      .subscribe(rs => {
        this.clubMembers = rs;

        this.clubMembers.map(x => {
          x.lastNameLower = (x.lastName != null ? x.lastName.toLowerCase() : null)
          x.firstNameLower = (x.firstName != null ? x.firstName.toLowerCase() : null)
          x.middleNameLower = (x.middleName != null ? x.middleName.toLowerCase() : null)
        });

        this.filteredMembers = this.clubMembers.slice();
        this.filteredMembers.map((x) => {
          x.isChecked = false
        });

        this.controls[4].options = lodash.uniq(this.clubMembers.map(x => x.birthYear)).sort().map(x => ({ text: x, value: x }));
        this.controls[9].options = lodash.uniq(lodash.flatten(this.clubMembers.map(x => x.assignedTeams))).sort().map(x => ({ text: x, value: x }));
        this.controls[10].options = lodash.uniq(this.clubMembers.map(x => x.feeName)).filter(x => !!x).sort().map(x => ({ text: x, value: x }));
        this.spinnerService.hide();
        this.member_status = status;

        this.NoOfTryoutRegisteredMembers = this.filteredMembers.length;
        this.NoOfInvitedMembers = this.filteredMembers.filter(m => m.inviteStatusID > 0).length;
        this.NoOfNotInvitedMembers = this.NoOfTryoutRegisteredMembers - this.NoOfInvitedMembers;

        let s = '';
        if (this.member_status === '0') {
          s = 'registered';
        } else if (this.member_status === '1') {
          s = 'invited';
        } else if (this.member_status === '2') {
          s = 'not-invited';
        }

        /* Fixed: same page refresh content. */
        //this.router.navigateByUrl(this.baseLink + programName + '/' + programFeeID + '/' + s);

        this.activeRoute.queryParams.pipe(take(1)).subscribe(params => {
          const clubMember = this.clubMembers.find(m => m.userID === +params.ui);
          if (params.ui && clubMember) {
            //onMemberEdit(clubMember.userID, clubMember.inviteStatus, $event, clubMember)
            this.onMemberEdit(clubMember.userID, clubMember.inviteStatus, null, clubMember);
          } else {
            this.spinnerService.hide();
          }
        });
      });
  }

  resetCheckboxSelection() {
    this.isSelectAllCheckBox = false;
    this.isCheckAllCheckBox = false;
    this.selectedRecordIndex.length = 0;
    this.selectedRecordCUPFIDList.length = 0;
    this.selectedRecordInvite.length = 0;
    this.NoOfSelectedMember = 0;
    this.filteredMembers.forEach((x) => {
      x.isChecked = false
    });
  }

  refreshReocrds() {
    this.getClubProgramQuestionsAndAnswersByClubProgramID();
    this.getMemberCount();
    this.getMembersbyStatus(status);
    this.filterMembers(this.routeParams.name, this.routeParams.id, this.member_status);
    this.resetCheckboxSelection();

    this.NoOfSelectedMember = this.selectedRecordIndex.length;
  }

  getMembersbyStatusData() {
    this.getMembersbyStatus(status);
  }


  toggleSideOverlay() {
    if (this.is_show_visible_column_panel) {
      this.is_show_visible_column_panel = false;
    } else {
      this.is_show_visible_column_panel = true;
    }
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(this.is_show_visible_column_panel);
  }

  onMemberSearch() {
    this.isShowMemberSearch = false;
    this.isShowPlayerAdjustment = false;
    this.isinviteMember = false;
    this.closeSideOverlay();

    this.searchModalOpen = true;
  }


  onSearch(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {
      const obj = {
        clubProgramID: Number(this.routeParams.id),
        firstName: (this.searchMemberForm.value.FirstName != null) ? this.searchMemberForm.value.FirstName : '',
        lastName: (this.searchMemberForm.value.LastName != null) ? this.searchMemberForm.value.LastName : '',
        gender: (this.searchMemberForm.value.Gender != null) ? this.searchMemberForm.value.Gender : '',
        age: Number(this.searchMemberForm.value.Age),
        email: (this.searchMemberForm.value.Email) ? this.searchMemberForm.value.Email : '',
        PaymentStatusVal: Number(this.searchMemberForm.value.PaymentType != null) ? this.searchMemberForm.value.PaymentType : '-1',
        inviteStatusID: Number((this.searchMemberForm.get('Invitation').value != null) ? this.searchMemberForm.get('Invitation').value : ''),
      };
      this.disableMemberSearchControls();
      event.target.disabled = true;
      event.target.innerHTML = 'Searching <i class="fa fa-spinner fa-spin push-5-r"></i>';
      this.tryoutMemberService.getTryoutMemberBySearch(obj).subscribe((data: any) => {
        event.target.innerHTML = '<i class="fa fa-search"></i> Search';
        event.target.disabled = false;
        this.searchMemberForm.reset();
        this.enableMemberSearchControls();
        this.closeSideOverlay();
        this.clubMembers = data;
        this.alertMessage('success', 'Member successfully searched.');
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    }
  }
  onResetSearch(event) {
    event.stopPropagation();
    this.searchMemberForm.reset();
    //this.getMembersbyStatus(status);
    this.refreshReocrds();
    this.closeSideOverlay();
  }

  enableMemberSearchControls() {
    for (const i in this.searchMemberControls) {
      if (this.searchMemberControls.hasOwnProperty(i)) {
        const control = this.searchMemberForm.get(this.searchMemberControls[i]);
        control.enable();
      }
    }
  }
  disableMemberSearchControls() {
    for (const i in this.searchMemberControls) {
      if (this.searchMemberControls.hasOwnProperty(i)) {
        const control = this.searchMemberForm.get(this.searchMemberControls[i]);
        control.disable();
      }
    }
  }

  onMemberEdit(userID, status, event, user) {
    if (event)
      event.stopPropagation();

    this.selectedMember = user;

    this.tryoutMemberService.getMemberInfo(userID, this.routeParams.id).subscribe((res: any) => {
      if (res.length) {
        this.selectedMember.playerformList = res[0].playerformList;
      }
    });
    this.ProgramName = this.routeParams.name;
    this.MemberUserID = userID;
    this.MemberStatus = status;
    this.ismessageSelected = true;
    this.isShowMemberSearch = false;
    this.isShowPlayerAdjustment = true;
    this.isinviteMember = false;
    this.changingValue.next(this.MemberUserID);
    this.openSideOverlay();
    this.getTryoutRegistrationPlayerInvitationHistoryByID();
  }

  openSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(true);
  }

  closeSideOverlay() {
    this.ismessageSelected = true;
    this.issetQuestionselected = false;
    this.iscustomQuestionSelected = false;
    this.adjustingFeeOpen = false;
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);

    this.resetCheckboxSelection();
  }
  isAgeValid() {
    return this.searchMemberForm.get('Age').errors
      && (this.searchMemberForm.get('Age').touched
        || this.searchMemberForm.get('Age').dirty);
  }


  /* ============= EDIT FEE PLAN (TODO: Move this code to separate component) ============= */
  initFeePlanForm() {
    this.feePlanForm = this.fb.group({
      FeePlan: ['', [Validators.required]]
    });
    this.popupConfirmFeePlanForm = this.fb.group({
      confirmFeePlan: [null, [Validators.required, Validators.pattern(this.alphaNumericPattern)]]
    });
  }
  openPopupFeePlan() {
    this.isOpenConfirmCorrectPopup = true;
  }
  closePopupFeePlan() {
    const control = this.popupConfirmFeePlanForm.get('confirmFeePlan');
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
    this.isOpenConfirmCorrectPopup = false;
  }
  onPopUpConfirmFeePlan(event, formValue) {
    event.stopPropagation();
    const flag = this.isCorrectTextMatched();
    if (flag) {
      // this.closePopup();
      this.saveFeePlan(event);
    } else {
      this.validateFeePlanUi();
    }
  }
  isCorrectTextMatched() {
    const val = this.popupConfirmFeePlanForm.get('confirmFeePlan').value;
    if (val) {
      return (val.trim() === 'APPROVE') ? true : false;
    }
  }
  isConfirmCorrectValid() {
    return this.popupConfirmFeePlanForm.get('confirmFeePlan').errors
      && (this.popupConfirmFeePlanForm.get('confirmFeePlan').touched
        || this.popupConfirmFeePlanForm.get('confirmFeePlan').dirty);
  }
  isFeePlanValid() {
    return this.feePlanForm.get('FeePlan').errors
      && (this.feePlanForm.get('FeePlan').touched
        || this.feePlanForm.get('FeePlan').dirty);
  }
  validateFeePlanUi() {
    Object.keys(this.popupConfirmFeePlanForm.controls).forEach(field => {
      const control = this.popupConfirmFeePlanForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  onSubmit(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {
      this.openPopupFeePlan();
    } else {
      this.validateFeePlanUi();
    }
  }
  saveFeePlan(event) {
    const obj = {
      ClubUserProgramFeeID: Number(this.clubUserProgramFeeID),
      ClubProgramFeeID: Number(this.clubProgramFeeID),
      AdminID: 1,
      FeePlan: Number(this.feePlanForm.value.FeePlan),
    };
    event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;
    this.playerAdjustmentService.saveFeePlan(obj).subscribe((data: any) => {
      event.target.innerHTML = 'Save';
      event.target.disabled = false;
      this.feePlanForm.reset();
      this.closePopupFeePlan();
      this.closeSideOverlay();
      this.alertMessage('success', data.result);
    }, error => {
      this.alertMessage('error', error.statusText);
    });
  }
  onReset(event) {
    event.stopPropagation();
    this.feePlanForm.reset();
    this.closeSideOverlay();
  }

  get selectedMembers() {
    return this.clubMembers.filter(c => this.selectedRecordIndex.indexOf(c.userID) > -1);
  }

  onExportMember() {
    const presetQuestions = ['player first name', 'player last name', 'player date of birth', 'player gender', 'address', 'city', 'state', 'zip', 'player email (13 years old & above)', 'position'];
    DownloadUtil.toCSV(
      this.clubMembers.filter(c => this.selectedRecordIndex.indexOf(c.userID) > -1).map(x => {
        let questionAndAnswer = this.questionAndAnswerList.filter(a => a.userID === x.userID);
        if (questionAndAnswer) {

          let presetQuestionAnswers: any = {
            'First Name': x.firstName,
            'Last Name': x.lastName,
            'DOB': new Date(x.dob).toLocaleDateString(),
            'Email': x.email,
            'Age': x.age,
            'Birth Year': x.dobText.substr(6),
            'Gender': x.gender ? x.gender.toLowerCase() === 'f' ? 'Female' : x.gender.toLowerCase() === 'm' ? 'Male' : x.gender : x.gender,
            'Address': x.address ? x.address.replace(/,/g, " ") : "",
            //'Address': x.address ? x.address.replace(",", " ") : "",
            'City': x.city,
            'State': x.stateName,
            'Zip': x.zip,
            'Group / Fee': x.feeName || '',
            'Invited Teams': `"${x.inviteTeamName || ''}"`,
            'Invitation Status': x.inviteStatus,
            'Payment Status': x.paymentStatus,
            'Date Registered': new Date(x.dateRegistered).toLocaleDateString(),
            'Position': x.position,
            'Parent First Name': x.parentFirstName,
            'Parent Last Name': x.parentLastName,
            'Parent Email': x.parentEmail,
            'Parent Phone': InputUtil.maskPhoneNumberInput(x.parentPhone)
          };

          const uniqueQuestionsAndAnswers = questionAndAnswer.filter(item => {
            return !presetQuestions.some(presetItem => presetItem.toLowerCase() == item.label.toLowerCase());
          });

          let customQuestionAnswers = {};

          uniqueQuestionsAndAnswers.forEach(data => {
            if (data && data.label) {
              data.label = data.label.replace(/,/g, " ");
              data.answer = data.answer ? data.answer.replace(/,/g, " ").replace(/\n/g, " ") : '';
              if (data.label != 'Photo') {
                if (data.label != 'Player Cell Phone')
                  customQuestionAnswers[data.label] = data.answer;
                else
                  customQuestionAnswers[data.label] = InputUtil.maskPhoneNumberInput(data.answer);
              }
            }
          });

          var qustionAnswers = {
            ...presetQuestionAnswers,
            ...customQuestionAnswers
          };
          // console.log("qustionAnswers =>", qustionAnswers);

          return qustionAnswers;
        }
        return "";
      })
    );
  }

  onExportMemberOld() {
    const presetQuestions = ['player first name', 'player last name', 'player date of birth', 'player gender', 'address', 'city', 'state', 'zip', 'player email (13 years old & above)'];
    this.answers.pipe(filter(p => !!p)).subscribe(ans => {
      const questions: string[] = lodash.uniq(
        ans.filter(a => this.selectedRecordIndex.indexOf(a.userID) > -1)
          .map(a => a.question)
          .filter(q => presetQuestions.indexOf(q.toLowerCase()) === -1)
      );
      DownloadUtil.toCSV(this.clubMembers.filter(c => this.selectedRecordIndex.indexOf(c.userID) > -1).map(x => {
        const answers = ans.filter(a => a.userID === x.userID);
        //console.log("testing:", new Date(x.dob).toLocaleDateString());

        let row: any = {
          'First Name': x.firstName,
          'Last Name': x.lastName,
          'DOB': new Date(x.dob).toLocaleDateString(),
          'Email': x.email,
          'Age': x.age,
          'Birth Year': x.dobText.substr(6),
          'Gender': x.gender,
          'Address': x.address ? x.address.replace(",", " ") : "",
          'City': x.city,
          'State': x.stateName,
          'Zip': x.zip,
          'Group / Fee': x.feeName || '',
          'Invited Teams': `"${x.inviteTeamName}"`,
          'Invitation Status': x.inviteStatus,
          'Payment Status': x.paymentStatus,
          'Date Registered': new Date(x.dateRegistered).toLocaleDateString()
        };
        questions.forEach(q => {
          const answer = (answers || []).find(a => a.question === q && a.answer);
          row[q] = `"${answer && answer.answer || ''}"`;
        });
        row = {
          ...row,
          'Parent First Name': x.parentFirstName,
          'Parent Last Name': x.parentLastName,
          'Parent Email': x.parentEmail,
          'Parent Phone': InputUtil.maskPhoneNumberInput(x.parentPhone),
          'Position': x.position
        };
        return row;
      }), 'tryout-members.csv');
    });
  }

  onMailTo() {
    this.emailModalOpen = true;
  }

  /* ================================== END //EDIT FEE PLAN ================================== */

  closeOverlay(event = null) {
    if (event) {
      event.stopPropagation();
    }
    this.searchModalOpen = false;
  }

  searchMembers(f) {
    const invitedTeamID = f.invitedTeamID;
    const assignedTeam = f.assignedTeam;
    delete f.invitedTeamID;
    delete f.assignedTeam;
    this.filteredMembers = this.commonService.search(this.clubMembers, f);
    if (invitedTeamID) {
      this.filteredMembers = this.filteredMembers.filter(m => m.invitedTeams && m.invitedTeams.indexOf(+invitedTeamID) > -1);
    }
    if (assignedTeam) {
      this.filteredMembers = this.filteredMembers.filter(m => m.assignedTeams && m.assignedTeams.indexOf(assignedTeam) > -1);
    }
  }

  navigateMembers(status: number) {
    this.selectedStatus = status;
    switch (+status) {
      case 0:
        this.filteredMembers = this.clubMembers.slice();
        break;
      case 1:
        this.filteredMembers = this.clubMembers.filter(m => m.inviteStatusID > 0);
        break;
      case 2:
        this.filteredMembers = this.clubMembers.filter(m => m.inviteStatusID === 0);
        break;
    }
  }

  showFeeAdjustment(fee) {
    this.adjustingFee = fee;
    this.adjustingFeeOpen = true;
  }

  get isCamps(): boolean {
    return this.router.url.startsWith('/camps-clinics-billing');
  }

  get baseLink(): string {
    return this.router.url.startsWith('/camps-clinics-billing') ? 'camps-clinics-billing/members/'
      : '/tryoutmembers/';
  }

  onChangePlayerStatus(status) {
    if (status == 0) {
      this.onAssignMember();
    }
    if (status == 1) {
      this.inviteMember(this.reinvite);
    }
    if (status == 2) {
      this.declineUsers();
    }
    if (status == 3) {
      this.didNotMakeUsers();
    }
  }

  historyData: any;
  pendingList: any[] = [];
  getTryoutRegistrationPlayerInvitationHistoryByID() {
    this.spinnerService.show();
    this.tryoutProgramService.getTryoutRegistrationPlayerInvitationHistoryByID(this.MemberUserID, this.routeParams.id).subscribe(
      (rs: any) => {
        this.historyData = rs;
        this.pendingList = rs.pendingStatusList;
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.alertService.error("Something went wrong.")
        console.log(error.error);
      }
    );
  }

  onViewDocument(url) {
    if (url) {
      this.showModal = true;
      this.formPath = url;
    } else {
      this.alertService.info('Sorry, there is no data to display.');
    }
  }

  closeModal() {
    this.showModal = false;
    this.formPath = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-members/tryout-members.component.ts